module.exports = jQuery.fn.magnificPopup;